// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"06c248f8","251":"12d88c69","628":"dc843dd0"}[chunkId] + ".chunk.js";
};